var exports = {
  "Af": "x93eb46d8--769eb0--card_desktop",
  "wL": "x93eb46d8--769eb0--card_phone",
};

module.exports = exports;
